import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const OnboardingWelcomeBack: Illustration = (props) => (
  <svg viewBox="0 0 240 260" {...illustrationProps(props, { width: 240 })}>
    <path
      fill="#FFB3B3"
      d="M192.243 12.605c3.202 7.527 6.412 15.044 9.614 22.57l1.379 3.244c.822 1.923 3.727.603 2.904-1.328-3.203-7.527-6.412-15.044-9.615-22.57l-1.379-3.244c-.822-1.922-3.727-.603-2.903 1.328Z"
    />
    <path
      fill="#FFB3B3"
      d="m188.256 31.323 21.723-9.743c1.012-.456 2.023-.911 3.036-1.358 1.871-.843.56-3.816-1.321-2.98l-21.722 9.744c-1.012.455-2.024.91-3.037 1.357-1.87.844-.559 3.816 1.321 2.98Z"
    />
    <path
      fill="#FFB3B3"
      d="m202.307 10.654-8.748 22.796c-.415 1.093-.839 2.18-1.253 3.272-.745 1.954 2.224 3.157 2.969 1.204l8.748-22.797c.415-1.093.839-2.179 1.254-3.272.745-1.953-2.225-3.157-2.97-1.203Z"
    />
    <path
      fill="#FFB3B3"
      d="M186.497 20.917c7.406 2.954 14.806 5.918 22.212 8.872l3.105 1.244c1.914.768 3.068-2.26 1.154-3.028-7.4-2.964-14.806-5.918-22.206-8.882l-3.104-1.244c-1.914-.768-3.068 2.26-1.154 3.028l-.007.01Z"
    />
    <path
      fill="#FF9494"
      d="M58.672 124.173c-.778-1.742-1.541-3.493-2.23-5.271-.46-1.196.043-2.46 1.2-3.018 1.09-.525 2.579.078 3.018 1.2.68 1.756 1.433 3.486 2.202 5.208 1.822-.815 3.653-1.618 5.513-2.338 1.197-.461 2.46.042 3.019 1.199.524 1.091-.078 2.58-1.2 3.018-1.839.713-3.65 1.505-5.452 2.311.82 1.82 1.657 3.634 2.57 5.413.58 1.139-.141 2.51-1.2 3.018-1.168.567-2.47-.136-3.018-1.199-.903-1.752-1.73-3.548-2.542-5.35-1.738.785-3.47 1.587-5.17 2.46-1.139.58-2.51-.142-3.018-1.2-.566-1.168.137-2.469 1.2-3.018 1.673-.863 3.387-1.656 5.108-2.433Z"
    />
    <circle
      cx="58.484"
      cy="26.926"
      r="7.507"
      stroke="#FFC7C7"
      strokeWidth="4"
    />
    <path
      fill="#FF9494"
      d="M237.941 66.605c-.17-1.094-.745-2.143-1.604-2.744-.826-.573-1.967-.654-2.915-.529-.615.081-1.15.251-1.644.673-.38.323-.648.77-.818 1.264-.453.197-.728.654-.777 1.237-.089 1.04.283 2.09.899 2.878.235.467.551.852 1.004 1.094.486.26.996.422 1.522.511 1.118.189 2.446.27 3.353-.618.356-.35.534-.798.591-1.282.065-.108.122-.216.17-.323.292-.7.332-1.408.219-2.161Zm-4.284.296s.016-.018 0 0Z"
    />
    <path
      fill="#76C82E"
      d="m114.427 58.838 8.435 5.78 4.415-9.223c7.096-14.825 25.18-20.658 39.601-12.775 14.337 7.837 19.232 26.055 10.754 40.022l-32.103 52.89a5.12 5.12 0 0 1-6.84 1.833l-54.247-29.753c-14.326-7.857-19.195-26.081-10.698-40.037 8.548-14.038 27.125-18.028 40.683-8.737Z"
    />
    <path
      fill="#FFC7C7"
      d="m220.228 102.807.776 2.057 1.911-1.088a6.198 6.198 0 1 1 5.584 11.05l-10.667 4.743a2.898 2.898 0 0 1-3.773-1.36l-5.183-10.461a6.198 6.198 0 1 1 11.352-4.941Z"
    />
    <path
      fill="#FFB3B3"
      d="m14.338 66.422 1.707.767.491-1.806a5.277 5.277 0 1 1 10.022 3.267l-3.546 9.287a2.466 2.466 0 0 1-3.087 1.459L10.5 76.239a5.277 5.277 0 1 1 3.839-9.817Z"
    />
    <path
      fill="#D8A060"
      d="M176.308 155.352s14.412-9.029 15.901-9.971c5.872-3.718 16.39-7.267 20.55-1.474.816 1.132.518 2.724-.605 3.549l-24.582 18.014-3.416 2.401a18.487 18.487 0 0 1-6.411 2.87l-2.837.664-49.889 11.618 32.035-27.256 19.256-.41-.002-.005Z"
    />
    <path
      fill="#D8A060"
      d="m206.815 178.661-95.867 12.642 47.294-20.704s33.558-1.253 38.521-1.46c4.394-.177 9.863 3.577 11.172 7.72.259.826-.266 1.684-1.122 1.796l.002.006ZM154.622 157.243l3.2-11.31.084.399 15.695-11.157s6.846-15.569 7.549-17.181c2.769-6.375 9.471-15.22 16.166-12.768 1.31.479 1.964 1.961 1.491 3.275l-10.21 28.714-1.475 3.904a18.52 18.52 0 0 1-3.687 5.975l-1.977 2.14-19.05 20.647-7.792-12.636.006-.002Z"
    />
    <path
      fill="#D8A060"
      d="M123.512 112.929c1.422 5.654-3.692 16.115-10.615 22.657-4.728 16.817 1.621 28.716 12.755 31.102 11.505 2.466 26.037-2.25 24.829-24.567-.184-3.398-1.64-6.233-3.638-8.862l7.468-12.377c7.867 5.003 11.12 6.132 12.46 10.236.84 2.574 1.32 8.546 1.573 13.015.176 3.112.241 5.494.241 5.494l.274-.125c-2.786 8.786-7.857 25.442-9.541 30.984l-96.36 72.937s-11.186-8.388-14.258-22.37c-2.125-9.674 3.072-24.048 3.072-24.048s5.825-3.663 12.354-8.199c8.648-6.009 14.739-14.908 17.704-25.013 7.03-23.964 6.585-32.971 12.062-39.827 3.791-4.748 24.244-22.451 26.278-24.078 1.16-.925 2.477-.4 3.342 3.041Z"
    />
    <path
      stroke="#AD7938"
      strokeLinecap="round"
      strokeWidth="3"
      d="M167.457 137.896c.649 4.665.229 9.486.297 14.185.032 2.205.29 4.436.152 6.637-.207 3.301-2.656 6.163-4.195 9.061M182.076 148.284l-8.485 9.841M180.791 168.79c-2.141 2.126-4.972 3.706-7.722 5.359-6.301 3.785-12.819 7.34-19.385 10.835"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth="3"
      d="M145.902 46.887c11.692-3.133 20.248 2.1 25.41 10.56"
    />
  </svg>
);
